import IconClose from '@assets/icons/close.svg?react';
import IconSearch from '@assets/icons/search.svg?react';
import { Box, IconButton, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

import customColors from '../../utils/customColors';

const FieldSearch = ({
 searchValue,
 setSearchValue,
 label,
}: {
 searchValue: string;
 setSearchValue: (value: string) => void;
 label: string;
}) => {
 const { t } = useTranslation();
 return (
  <Box
   sx={{
    pr: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${customColors.lightestGray}`,
   }}
  >
   <TextField
    size="small"
    value={searchValue || ''}
    label={label}
    variant="filled"
    fullWidth
    onChange={(e) => setSearchValue(e.target.value)}
    slotProps={{
     input: {
      disableUnderline: true,
     },
    }}
    sx={{
     border: 0,
     '& .MuiInputBase-root': {
      border: 0,
     },
    }}
   />

   <IconButton onClick={() => searchValue && setSearchValue('')}>
    {searchValue ? <IconClose /> : <IconSearch />}
   </IconButton>
  </Box>
 );
};

export default FieldSearch;
